import ExtensionsButton from './ExtensionsButton';

export default ExtensionsButton;
